module.exports = {
    FormIntegration: {
        activeClassNames: ["active", "ff_active"] ,
        allSelectors: [
            {
                tab: "#farefinder_tabbody_tickets",
                selectors: [
                    "#oneway",
                    "#return",
                    "#departs",
                    "#arrives",
                    "#wdfdate1",
                    "#wdfdate2",
                ],
            },
            {
                tab: "#farefinder_tabbody_redeem",
                selectors: [
                    "#ff_membernumber",
                    "#ff_memberpassword",
                    "#agrdeparts",
                    "#agrarrives",
                    "#wdfdate15",
                ],
            },
            {
                tab: "#farefinder_tabbody_otherdiscounts",
                selectors: [
                    "#othdeparts",
                    "#otharrives",
                    "#wdfdate16",
                ],
            },
            {
                tab: "#ff_tabbar_status",
                selectors:[
                    "#wdfdate10",
                    "#status_train_num",
                    "#status_from",
                    "#status_to",
                    "#status_arr",
                    "#status_dep",
                ],
            },
            {
                tab: "#ff_tabbar_mytrip",
                selectors: [
                    "#mytrip_res_num",
                    "#mytrip_res_email",
                    "#mytrip_res_zip",
                    "#ff_mytrip_step_1",
                    "#mytrip_acct_email",
                    "#mytrip_acct_pwd",
                    "#ff_mytrip_step_2",
                ],
            },
            {
                tab: "#container1",
                selectors: ["#station_city",
                            "#station_state",
                            "#station_zip",
                            "#trainonly",
                            "#busstations",
                            ],
            },
            {
                tab: "#container2",
                selectors: ["#code"],
            },
            {
                tab:"#cms_schedules",
                selectors: ["#cmsschedules_from",
                            "#cmsschedules_to",
                            "#wdfdate25",
                            "#wdftime25"],
            },
        ],
        forms: [
            {//farefinder
                activeClassNames: ["active", "ff_active"],
                tabs: ["#farefinder_tabbody_tickets",
                        "#ff_sub_tabbar_traveloptions",
                        "#ff_sub_tabbar_otherdiscounts",
                        "#ff_tabbar_status",
                        "#ff_tabbar_mytrip"],
            },
            {//station lookup
                activeClassNames: ["active_tab_content"],
                tabs: ["#container1","#container2"],
            },
            {//schedules
                activeClassNames: "none",
                tabs: ["#cms_schedules"],
            },           
        ],
        tabIds: [
            "farefinder_tabbody_tickets",
            "ff_sub_tabbar_traveloptions",
            "ff_sub_tabbar_otherdiscounts",
            "ff_tabbar_status",
            "ff_tabbar_mytrip"],
    },       
};


// WEBPACK FOOTER //
// ./settings/form-integration.js